
<section class="container-fluid bg-white">
  <Table
    :data="this.domains || []"
    :columns="table.columns"
    :actionButton="table.actionButton"
    :disableSearch="false"
    :search="table.search"
    :actions="table.actions"
    @rowClicked="table.clickHandler"
  />
</section>
